(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name FormstepsController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('FormstepsController', FormstepsController);
    FormstepsController.$inject = ["AttributeformService"];

    function FormstepsController(AttributeformService){
  
        var vm = this;
        vm.cargando = false;
        vm.loading = false;
        vm.step1 = true;
        vm.step2 = false;
        vm.step3 = false;
        vm.sended = false;
        vm.json = { attributes:[]};
          
            vm.getattributes = function(){
              vm.cargando = true;
                AttributeformService.getparentAttribute(vm).then(function(data){ 
                  vm.parents = data.parents;
                  vm.cargando = false;
                }) 
          
            }

            vm.validate = function (value) {
                if (vm.json.attributes.indexOf(value) == -1){
                    vm.json.attributes.push(value);
                }else {
                    vm.json.attributes.splice(vm.json.attributes.indexOf(value), 1);
                }
            }

            vm.parentIdSeleccionado = function(parent_id){
                vm.cargando = true;
                    AttributeformService.parentId(parent_id).then(function(data){
                        vm.step1=false;
                    
                        vm.parentId = data.parentId;
                        vm.attributes = data.attributes;
                        vm.cargando = false;
                           if ( vm.parentId.id == 830) {
                               vm.step2 = false;
                               vm.step3 = true;  
                          }else{
                               vm.step2 = true;
                          }
                    })

                vm.step1=false;
                vm.step2=false;
            }

            vm.saveForm = function(form){
                if (!form.$valid) {
                  vm.success = false;
                    angular.element("[name='" + form.$name + "']").find('.ng-invalid:visible:first').focus();
                    return false;
                }

                if (vm.loading) {
                   return;
                }

                if (form.$valid) {
                  vm.loading = true;

                }
                    AttributeformService.SaveForm(vm).then(function(data){ 
                        vm.json = data.json;
                        console.log("json", vm.json);
                        vm.sended=true;
                        vm.loading = false;
                        form.$setPristine();  
                    }) 
            }
    }

})();